export enum UserRole {
    ADMIN = 'ADMIN',
    SUPER_ADMIN = 'SUPERADMIN',
    SUPPLIER = 'SUPPLIER',
    CLIENT = 'CLIENT'
}

export class User {
    id: string;
    username: string;
    password: string;
    firstName: string;
    lastName: string;
    roles: Array<UserRole>;
    token?: string;
}
